<template>
    <div class="cart-applicable-discounts-list-popover-content">
        <ApplicableDiscountsList
            :locationId="locationId"
            :cartId="cartId"
            :inOperatorApp="false"
            :selectedMainCartItemIds="selectedMainCartItemIds"
            @cartDiscountApplied="onCartDiscountApplied"
            @onClose="
                () => {
                    close();
                }
            "
            @applyDiscountErrorOccurred="onApplyDiscountError"
        />
    </div>
</template>

<script setup lang="ts">
    import type { DaoError } from "@/data/dao/service/BaseServiceDao";
    import { onApplyDiscountErrorOccurred } from "@/data/services/DiscountsService";
    import { translations } from "@/shared/localization/translations";

    import ApplicableDiscountsList from "@/operator/components/allocation/ApplicableDiscountsList.vue";

    // define props
    const props = defineProps<{
        locationId: string;
        cartId: string;
        onClose: () => void;
        selectedMainCartItemIds: string[];
    }>();

    // define html refs
    const emit = defineEmits(["close"]);

    function onCartDiscountApplied() {
        close();
    }

    function onApplyDiscountError(error: DaoError) {
        onApplyDiscountErrorOccurred(
            error,
            { containerClass: "cart-applicable-discounts-error-popup" },
            $("body"),
            translations.pay.failedNoItemsSelected
        );
    }

    function close() {
        emit("close");
        props.onClose();
    }
</script>

<style lang="scss">
    .cart-applicable-discounts-list-popover-content {
        padding: 0 0 3.5em;
    }

    .cart-applicable-discounts-list-popover-content .applicable-discount-tile {
        flex: 0 0 47% !important;
        max-width: 47% !important;
    }
</style>
